// utils/currencyFormatter.js

import { getPathVariables } from "../misc";

// Function to format currency
export const formatCurrency = price => {
    
    const locale = getPathVariables(window.location.pathname)[0];
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });
    const updatedprice = formatter.format(price);
    return updatedprice;
  };